<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-template #tooltipTemplate><ng-content select="[projectedTooltip]"></ng-content></ng-template>

<div>
  @if (this.Mode === 'design') {
    <div class="flex-row-top-right">
      <div class="fill-remaining-space">
        <!-- If there are instructions, display label first, then instructions then field -->
        @if (this.HasInstructions) {
          @if (this.DisplayName) {
            <div class="design-mode-field-label">{{this.DisplayName}} @if (this.FormField.required) {
              <span style="color: #EF0000;">*</span>
            }</div>
          }
          <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
        }
        <!-- //VNEXT-561: KLW - Have required label show in design -->
        <mat-form-field appearance="outline" [floatLabel]="'always'" [hideRequiredMarker]="true">
          @if (this.ShowLabel && !this.HasInstructions) {
            <mat-label
              class="design-mode-field-label">
              {{this.DisplayName}} @if (this.FormField.required) {
              <span style="color: #EF0000;">*</span>
            }
          </mat-label>
        }
        <input matInput
          type="number"
          placeholder="{{this.PlaceholderText}}"
          value="{{this.DefaultValue}}"
          disabled
          [required]="this.FormField.required"
          [attr.aria-label]="this.DisplayName" />
        </mat-form-field>
      </div>
      <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
      @if (this.ShowFormattedValue) {
        <div class="design-mode-formatted-value-div">
          <!--<span>{{this.DefaultValue | number:'1.0-0'}}</span>-->
          <span>{{this.DesignModePreviewValue | number:'1.0-0'}}</span>
        </div>
      }
    </div>
  }

  @if (((this.Mode === 'preview') || (this.Mode === 'instance')) && (! this.ShowFormattedValue)) {
    <div
      class="flex-row-top-right">
      <div class="fill-remaining-space">
        @if ((this.ControlType === 'Reactive Forms') && (this.FormControl !== null)) {
          <!-- If there are instructions, display label first, then instructions then field -->
          @if (this.HasInstructions) {
            @if (this.DisplayName) {
              <div class="field-label">{{this.DisplayName}} @if (this.FormField.required) {
                <span style="color: #EF0000;">*</span>
              }</div>
            }
            <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
          }
          <mat-form-field appearance="outline" [floatLabel]="'always'" [hideRequiredMarker]="true" subscriptSizing="dynamic">
            <!-- If there are no instructions, display label integrated into the field -->
            @if (this.ShowLabel && !this.HasInstructions && !FieldIsInGrid) {
              <mat-label class="field-label">
                {{this.DisplayName}}
                @if (this.FormField.required) {
                  <span style="color: #EF0000;">*</span>
                }
              </mat-label>
            }
            @if (! this.ReadOnly) {
              <input matInput
                IntegerOnly
                type="text"
                id="{{this.MatInputId}}"
                placeholder="{{this.PlaceholderText}}"
                [formControl]="this.FormControl"
                (blur)="this.handleOnBlur()"
                (focus)="this.handleOnFocus($event)"
                [required]="this.FormField.required"
                [attr.aria-label]="this.DisplayName" />
              }
              @if (this.ReadOnly) {
                <input matInput
                  readonly
                  type="number"
                  id="{{this.MatInputId}}"
                  placeholder="{{this.PlaceholderText}}"
                  [formControl]="this.FormControl"
                  (blur)="this.handleOnBlur()"
                  (focus)="this.handleOnFocus($event)"
                  [required]="this.FormField.required"
                  [attr.aria-label]="this.DisplayName" />
                }
              </mat-form-field>
            }
          </div>
          <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
        </div>
      }

      <!--class="input-with-formatted-value-div"-->
      @if (((this.Mode === 'preview') || (this.Mode === 'instance')) && this.ShowFormattedValue) {
        <div
          class="{{this.PreviewInstanceModesOutDivCssClass}}">
          <div class="show-formatted-value-mat-form-field-div">
            @if ((this.ControlType === 'Reactive Forms') && (this.FormControl !== null)) {
              <mat-form-field appearance="outline" [floatLabel]="'always'">
                @if (this.ShowLabel) {
                  <mat-label>
                    {{this.DisplayName}} @if (this.FormField.required) {
                    <span
                    style="color: #EF0000;">*</span>
                  }
                </mat-label>
              }
              <input matInput
                IntegerOnly
                type="text"
                id="{{this.MatInputId}}"
                placeholder="{{this.PlaceholderText}}"
                step="0.01"
                [formControl]="this.FormControl"
                (blur)="this.handleOnBlur()"
                (focus)="this.handleOnFocus($event)"
                [attr.aria-label]="this.DisplayName"
                [attr.aria-required]="this.FormField.required" />
                @if (this.HasTooltipText) {
                  <mat-icon matSuffix matTooltip="{{this.TooltipText}}">info</mat-icon>
                }
              </mat-form-field>
            }
          </div>
          <div class="show-formatted-value-formatted-value-div">
            @if (this.FormControl !== null) {
              <span>{{this.FormControl.value | number:'1.0-0'}}</span>
            }
          </div>
          <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
        </div>
      }
    </div>
